import { useEffect, useRef } from 'react';
import { SubmittedInvite } from '../lib/api';
import { useAnimatedClose } from '../hooks/useAnimatedClose';

export function SubmittedRsvpPanel({ open, invite, onClose }: { open: boolean; invite: SubmittedInvite; onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const { closing, requestClose } = useAnimatedClose(onClose);

  useEffect(() => { if (open) closeRef.current?.focus(); }, [open]);
  if (!open) return null;

  return <div className={`modal-backdrop ${closing ? 'is-closing' : ''}`} role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) requestClose(); }}>
    <section className="event-panel completed-rsvp-panel" role="dialog" aria-modal="true" aria-labelledby="submitted-rsvp-title">
      <button ref={closeRef} className="icon-button" onClick={() => requestClose()} aria-label="Close RSVP summary">×</button>
      <p className="eyebrow">RSVP received</p>
      <h2 id="submitted-rsvp-title">You're already on the list.</h2>
      <dl className="completed-rsvp-facts">
        <div><dt>RSVP</dt><dd>{invite.rsvpStatus === 'yes' ? 'Attending' : 'Not attending'}</dd></div>
        {invite.rsvpStatus === 'yes' && <div><dt>Party size</dt><dd>{invite.attendeeCount}</dd></div>}
        {invite.email && <div><dt>Contact</dt><dd>{invite.email}</dd></div>}
        {invite.phone && <div><dt>Phone</dt><dd>{invite.phone}</dd></div>}
        {invite.jeffismSubmitted && <div><dt>Jeffism</dt><dd>Submitted</dd></div>}
      </dl>
      <p className="completed-rsvp-note">Need to change something? Use the organizer form under Event details.</p>
    </section>
  </div>;
}
